// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + {"87":"e09f226e","481":"c50db854"}[chunkId] + "." + {"87":"e7c94cd5d63e19d1","481":"ab26931e75285f33"}[chunkId] + ".js";
};